import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLogger } from "../services/axiom";

/** Logs SPA navigations so page views show up alongside backend logs in Axiom. */
export function RouteLogger() {
  const location = useLocation();
  const log = useLogger();

  useEffect(() => {
    log.info("Page view", {
      path: location.pathname,
      search: location.search,
    });
  }, [location.pathname, location.search, log]);

  return null;
}
